<script>
import Layout from '../../layouts/main';
// import { Carousel, Slide } from "vue-carousel";
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import Enquiry from './Form/Enquiry';
import LoanScheduleDraft from './Form/LoanSchedule';
import Swal from 'sweetalert2';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import customerService from '../../../api/customerService';
import RequireInstall from '@/views/pages/customer/Form/installer.vue';
import Inspection from '@/views/pages/customer/Form/Inspection.vue';
import Live from '@/views/pages/customer/Form/Live.vue';

export default {
  components: {
    Layout,
    Enquiry,
    LoanScheduleDraft,
    // Carousel,
    // Slide,
    FormWizard,
    TabContent,
    RequireInstall,
    Inspection,
    Live
},
  data() {
    return {
      progress: [
        {
          title: 'Enquiry',
          icon: 'uil-file-plus',
        },
        {
          title: 'Loan Schedule & Documents',
          icon: 'uil-schedule',
        },
        {
          title: 'Require Install',
          icon: 'uil-processor',
        },
        {
          title: 'Final Inspection & Loan Disbursement',
          icon: 'uil-file-search-alt',
        },
        {
          title: 'Live',
          icon: 'uil-check',
        },
      ],
      form: null,
      formStatus: 0,
      loaded: true,
      quickEntryMode: false,
      targetStatus: 4,
      statusOptions: [
        { value: 0, text: 'Enquiry Only' },
        { value: 1, text: 'Enquiry Verified' },
        { value: 2, text: 'Loan Approved' },
        { value: 3, text: 'Installation Complete' },
        { value: 4, text: 'Fully Approved & Live' }
      ]
    };
  },
  computed: {
    onEditId() {
      return this.$route.query.id;
    },
    formWizard() {
      return this.$refs.formWizard;
    },
    formProgress() {
      return [
        {
          title: 'Require Install',
          icon: 'uil-processor',
        },
      ]
    },
    role_id() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      
      return userData? userData.role_id : null
    },
    edit_permission() {
      const editable = [1,2]
      return !editable.includes(this.role_id)
    }
  },
  methods: {
    beforeChange() {
      return false
    },
    handleStepChange() {
      return new Promise((resolve, reject) => {
        reject()
     })
    },
    async saveEnquiry() {
      Swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
      });
    },
    async getData() {
      this.loaded = false
      //Loading Swal
      Swal.fire({
        title: 'Loading...',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        },
        showConfirmButton: false,
      });

      this.form = await customerService.show(this.onEditId)
      this.formStatus = this.form.status
      if (this.role_id == 3 && this.formStatus == 3) {
        const target = this.form.comments.filter(e => e.staff.role_id == 3 && e.case.includes('Install'))
        if (target.length) {
          this.formStatus = 3
        } else {
          this.formStatus = 2
        }
      }
      setTimeout(() => {
        Swal.close()
      }, 1000);

      this.loaded = true
    },
    
    async saveQuickEntry() {
      try {
        // Show loading
        Swal.fire({
          title: 'Saving...',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
          showConfirmButton: false,
        });
        
        // Wait for next tick to ensure all components are mounted
        await this.$nextTick();
        
        // Debug: Check what refs are available
        console.log('Available refs:', Object.keys(this.$refs));
        console.log('loanForm ref:', this.$refs.loanForm);
        
        // Try to access the components directly and check their methods
        const enquiryForm = this.$refs.enquiryForm;
        const loanForm = this.$refs.loanForm;
        const installForm = this.$refs.installForm;
        const inspectionForm = this.$refs.inspectionForm;
        
        console.log('enquiryForm:', enquiryForm);
        console.log('loanForm:', loanForm);
        console.log('installForm:', installForm);
        console.log('inspectionForm:', inspectionForm);
        
        if (loanForm) {
          console.log('loanForm methods:', Object.getOwnPropertyNames(loanForm));
          console.log('loanForm.$options.methods:', loanForm.$options.methods ? Object.keys(loanForm.$options.methods) : 'No methods');
        }
        
        // Check if all components and methods exist
        if (!enquiryForm || !enquiryForm.getFormData) {
          throw new Error('Enquiry form or getFormData method not available');
        }
        if (!loanForm || !loanForm.getFormData) {
          throw new Error('Loan form or getFormData method not available');
        }
        if (!installForm || !installForm.getFormData) {
          throw new Error('Installation form or getFormData method not available');
        }
        if (!inspectionForm || !inspectionForm.getFormData) {
          throw new Error('Inspection form or getFormData method not available');
        }
        
        // Gather data from all form sections
        const enquiryData = enquiryForm.getFormData();
        const loanData = loanForm.getFormData();
        const installData = installForm.getFormData();
        const inspectionData = inspectionForm.getFormData();
        
        // Prepare payload
        const payload = {
          customer: enquiryData.customer,
          enquiry: enquiryData.enquiry,
          enquiry_files: enquiryData.enquiry_files,
          vehicle: enquiryData.vehicle,
          loan: loanData.loan,
          installation: installData.installation,
          inspection: inspectionData.inspection,
          target_status: this.targetStatus,
          lender_id: loanData.lender_id,
          installer_id: installData.installer_id
        };
        
        // Add customer_id if editing
        if (this.onEditId) {
          payload.customer_id = this.onEditId;
        }
        
        // Debug logging
        console.log('Frontend Debug:');
        console.log('onEditId:', this.onEditId);
        console.log('payload.customer_id:', payload.customer_id);
        console.log('Full payload:', JSON.stringify(payload, null, 2));
        
        // Call API - pass customer ID if editing
        await customerService.quickEntry(payload, this.onEditId);
        
        // Show success
        const isEditing = !!this.onEditId;
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: isEditing ? 'Customer information updated successfully' : 'Customer information saved successfully',
          confirmButtonText: 'OK'
        }).then(() => {
          // Redirect to customer list or stay on edit page
          if (isEditing) {
            // Refresh the data to show updated information
            this.getData();
          } else {
            // Redirect to customer list for new customers
            this.$router.push({ name: 'customer' });
          }
        });
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Failed to save customer information'
        });
      }
    }
  },
  async mounted() {
    if (this.onEditId) {
      this.getData()
    }
  }
};
</script>

<template>
  <Layout>
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Customer Information: {{ form?.name }}</h4>
          
          <!-- Add Quick Entry Mode toggle for Admin -->
          <div v-if="role_id === 1" class="mb-3">
            <b-form-checkbox v-model="quickEntryMode" switch>
              <strong>Quick Entry Mode</strong> - Bypass approval workflow
            </b-form-checkbox>
          </div>
          
          <!-- Regular form wizard when not in quick entry mode -->
          <form-wizard v-if="loaded && role_id != 5 && !quickEntryMode" :startIndex="formStatus" refs="form-wizard" color="#5b73e8">
            <tab-content v-for="({ title, icon }, i) in progress" :title="title" :icon="icon" :key="i">
              <div class="row">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">{{ title }}</h4>
                      <div class="mt-4">
                        <div v-if="i === 0">
                          <Enquiry
                            :edit_permission="edit_permission"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                          />
                        </div>
                        <div v-if="i === 1">
                          <LoanScheduleDraft
                            :edit_permission="edit_permission"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                          />
                        </div>
                        <div v-if="i === 2">
                          <RequireInstall
                            :edit_permission="edit_permission"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                          />
                        </div>
                        <div v-if="i === 3">
                          <Inspection
                            :edit_permission="edit_permission"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                          />
                        </div>
                        <div v-if="i === 4">
                          <Live
                            :edit_permission="false"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
          </form-wizard>
          
          <!-- Quick Entry Form for Admin -->
          <div v-if="loaded && role_id === 1 && quickEntryMode" class="quick-entry-form">
            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Quick Entry Form</h4>
                    <div class="mt-4">
                      <!-- All form sections in one page -->
                      <b-tabs content-class="mt-3">
                        <b-tab title="Customer Info" active>
                          <Enquiry
                            :edit_permission="false"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                            ref="enquiryForm"
                          />
                        </b-tab>
                        <b-tab title="Vehicle & Loan">
                          <LoanScheduleDraft
                            :edit_permission="false"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                            ref="loanForm"
                          />
                        </b-tab>
                        <b-tab title="Installation">
                          <RequireInstall
                            :edit_permission="false"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                            ref="installForm"
                          />
                        </b-tab>
                        <b-tab title="Inspection">
                          <Inspection
                            :edit_permission="false"
                            :form_data="form"
                            :getData="getData"
                            :role_id="role_id"
                            @refresh="getData"
                            ref="inspectionForm"
                          />
                        </b-tab>
                      </b-tabs>
                      
                      <!-- Target status selection -->
                      <div class="mt-4">
                        <b-form-group label="Set Customer Status">
                          <b-form-select v-model="targetStatus" :options="statusOptions"></b-form-select>
                        </b-form-group>
                      </div>
                      
                      <!-- Save All button -->
                      <div class="mt-4">
                        <b-button variant="primary" @click="saveQuickEntry">
                          Save All Information
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <form-wizard v-if="loaded && role_id == 5"  :startIndex="formStatus" refs="form-wizard" color="#5b73e8">
            <tab-content v-for="({ title, icon }, i) in formProgress" :title="title" :icon="icon" :key="i">
              <div class="row">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">{{ title }}</h4>
                      <div class="mt-4">
                        <RequireInstall
                          :edit_permission="edit_permission"
                          :form_data="form"
                          :role_id="role_id"
                          :getData="getData"
                          @refresh="getData"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
.wizard-card-footer {
  display: none;
}
.boxed {
  border: 5px solid #ebeff2;
  border-radius: 8px;
  padding: 10px;
  height: 75px;
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
